import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { ProductHintsItemFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { ProductHintsItemFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const productHintsItemDataMock: ProductHintsItemFragmentFragment = {
  iconUrl: 'https://bilder.baur.de/i/empiriecom/baurde_repair',
  text: 'Ersatzteil- und Reparatur-Service',
  serviceLayerId: 'hint_ersatzteil_reparatur',
};

export function getProductHintsItemFragmentedData(data?: ProductHintsItemFragmentFragment) {
  return makeFragmentData(data || productHintsItemDataMock, ProductHintsItemFragmentFragmentDoc);
}
